import { whatIfInnerSelector } from '../../../WhatIfsSelector';

const downPaymentAmount = (state, props) => (
  whatIfInnerSelector(state, props).DownPayment
);

export default downPaymentAmount;
